module.exports = __webpack_public_path__ + "img/hi.c22f46e2.jpg";